import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {Modal, ModalProps} from '@/components/common-components/components/modal';
import {Button} from './Button';
import {ReactNode, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowDownLeftAndArrowUpRightToCenter, faArrowUpRightAndArrowDownLeftFromCenter, faCheck} from '@fortawesome/pro-solid-svg-icons';
import {NextImg} from '@/utils/nextImg';


interface Props extends ModalProps {
  iconPath?: string;
  title?: string;
  subTitle?: string;
  videoLink: string;
  button1?: string;
  button3?: string | ReactNode;
  button2?: string | ReactNode;
  buttonMinimize?: boolean;
  onClickButton1?: ()=> void;
  onClickButton2?: ()=> void;
  onClickButton3?: (title)=> void;
}

export const VideoPlayerModal = observer(({
  iconPath = '/icons/text-icon.svg',
  title = 'How to Create a Content Calendar for SEO',
  subTitle = 'Content Tools',
  button1 = 'Open Tool',
  videoLink = `https://linkgraph.com/wp-content/uploads/2021/11/SEO-Content-Assistant720.webm`,
  button2 = <span><FontAwesomeIcon icon={faCheck} style={{marginRight: 5}}/>Mark as Done</span>,
  buttonMinimize = false,
  onClickButton1,
  onClickButton2,
  button3,
  onClickButton3,
}: Props) => {
  const {home: {videoPlayerModal, setVideoPlayerModal}} = useStore('');
  const [minimized, setMinimized] = useState(buttonMinimize);
  return (
    <>
      <ModalStyled
        destroyOnClose={true}
        style={{width: 'auto', display: 'flex', alignSelf: 'center'}}
        visible={videoPlayerModal && !minimized}
        onClose={() => setVideoPlayerModal(false)}
        maskStyle={{background: 'rgba(21,22,23, 0.95)'}}
      >
        <div>
          <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 22}}>
            <div style={{display: 'flex'}}>
              <NextImg style={{marginRight: 10}} src={iconPath}/>,
              <div>
                <TitleText>{title}</TitleText>
                <SubTitleText>{subTitle}</SubTitleText>
              </div>
            </div>
            <div style={{display: 'flex'}}>
              {!button3 && button1 ? <Button onClick={onClickButton1 ?? (() => {})}>{button1}</Button> : ''}
              {!button3 && button2 ? <Button onClick={onClickButton2 ?? (() => {})} color='green' mode='dark' variant='ghost'>
                {button2}</Button> : ''}
              {button3 ? <Button onClick={typeof(onClickButton3) == 'function' ? () => onClickButton3(title) : ()=>{}} color='green' mode='dark' variant='ghost'>
                {button3}</Button> : ''}
              <Button onClick={() => setMinimized(true)} color='textGrayLight' mode='dark' variant='ghost'>
                <FontAwesomeIcon style={{marginRight: 5}} icon={faArrowDownLeftAndArrowUpRightToCenter} />Minimize</Button>
            </div>
          </div>
          <div>
            <iframe
              width='1065'
              height='539'
              src={videoLink}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              title='Embedded youtube'
              style={{borderRadius: '8px'}}
            />
          </div>
        </div>
      </ModalStyled>
      <SmallPopupStyled style={{display: minimized && videoPlayerModal ? 'block' : 'none'}}>
        <div style={{position: 'relative'}}>
          <CloseOutlinedStyled onClick={() => setMinimized(false)}>
            <FontAwesomeIcon icon={faArrowUpRightAndArrowDownLeftFromCenter} />
          </CloseOutlinedStyled>
          <iframe
            width='360'
            height='183'
            src={videoLink}
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
            title='Embedded youtube'
            style={{borderRadius: '8px'}}
          />
        </div>

      </SmallPopupStyled>
    </>
  );
});

const TitleText = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #FFFFFF;
`;

const SubTitleText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #A3A4A4;
`;


const ModalStyled = styled(Modal)`
  max-height: 100% !important;
  
  .rc-dialog-close {
    margin-top: -25px;
    margin-right: -65px;
    color: #fff;
    font-size: 40px;
  }

  .rc-dialog-content {
    width: 1125px;
    height: 660px;
    background: rgba(78, 81, 86, 0.35);
    /* opacity: 0.35; */
    border-radius: 8px;
  }
`;

const SmallPopupStyled = styled.div`
  position: fixed;
  z-index: 99999999;
  right: 20px;
  bottom: 25px;
  padding: 10px;
  background-color: rgba(78, 81, 86, 0.35);
  border-radius: 8px;
`;

const CloseOutlinedStyled = styled.span`
    position: absolute; 
    top: -44px;
    pointer-events: all;
    right: 5px;
    font-size: 22px;
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;
